import { issuePolicy } from './../store/entities/policy-issue/policy-issue.action';
import { Injectable } from '@angular/core';
import { filter, firstValueFrom, Observable, switchMap, take, tap } from 'rxjs';
import { PolicyIssueAdapter } from '@core/adapters/policy-issue.adapter';
import { PolicyIssueRequest } from '../models/api/request/policy-issue-request.model';
import { PolicyIssueResponse } from '../models/api/response/policy-issue-response.model';
import { Store } from '@ngrx/store';
import { CoreState } from '../store/reducers';
import { PolicyIssueActions } from '../store/actions';
import { ProductType } from '../models/api/dsm-types';
import { ProductsService } from './products.service';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
  providedIn: 'root',
})
export class PolicyIssueService {
  constructor(
    private policyIssueAdapter: PolicyIssueAdapter,
    private store: Store,
    private productsService: ProductsService,
    private actions$: Actions
  ) {}

  policies(request: PolicyIssueRequest): Observable<PolicyIssueResponse> {
    return this.policyIssueAdapter.policies(request);
  }

  issuePolicyForProduct(product: ProductType): void {
    this.store.dispatch(PolicyIssueActions.issuePolicyForProduct({ product }));
  }

  issuePolicyAsPromise(quoteId: string): Promise<any> {
    return firstValueFrom(
      this.productsService.getProductByQuoteId(quoteId).pipe(
        take(1),
        switchMap((product) => {
          if (!product)
            throw new Error(`Product not found for quoteId ${quoteId}`);
          const result$ = this.actions$.pipe(
            ofType(
              PolicyIssueActions.issuePolicySuccess,
              PolicyIssueActions.issuePolicyFail
            ),
            filter((action) => action.product === product.type),
            tap((action) => {
              if (action.type === PolicyIssueActions.issuePolicyFail.type) {
                throw action;
              }
            })
          );
          this.issuePolicyForProduct(product.type);
          return result$;
        })
      )
    );
  }
}
